import $ from "jquery";
import urlUtil from "../../util/url";

const layoutSwitcher = {
  ACTIVE_CLASS: "layout-switcher__link--active",
  ENABLE_LAYOUT_TRANSITION_CLASS: "body--layout-transition-enabled",
  PREF_STORAGE_KEY: "tds.layoutPref",

  /**
   * Toggle between layouts based on layout link clicked
   * @param {object} $link
   */
  switchLayout($link) {
    const $parent = $link.parent(".layout-switcher");
    const layout = $link.attr("data-layout");

    if (layout !== this.getActiveLayout()) {
      $parent
        .find(".layout-switcher__link")
        .not($link)
        .removeClass(this.ACTIVE_CLASS);
      $link.addClass(this.ACTIVE_CLASS);

      this.removeLayoutClasses(this.$body);
      this.$body.addClass(`body-layout--${layout}`);
      this.adjustUrl(layout);
      this.adjustPaginationLinks(layout);
      this.saveLayoutState(layout);
    }
  },

  /**
   * When layout changes adjust param in pagination links.
   * @param {string} layout
   */
  adjustPaginationLinks(layout) {
    $("a.pagination__link").each(function () {
      const $this = $(this);
      const url = $this.prop("href");
      $this.prop("href", urlUtil.addReplaceParam("l", layout, url));
    });
  },

  /**
   * Based on new layout, adjust url
   * @param {string} layout
   */
  adjustUrl(layout) {
    let path = document.location.pathname;
    const newSearchString = urlUtil.addReplaceParam("l", layout);
    if (newSearchString) {
      path += newSearchString;
    }
    window.history.pushState(null, window.document.title, path);
  },

  /**
   * Save state to localStorage.
   * @param  {string} layout
   */
  saveLayoutState(layout) {
    window.localStorage.setItem(
      `${this.PREF_STORAGE_KEY}.${this.appSection}`,
      layout
    );
  },

  /**
   * Remove existing layout classes.
   * @param {object} $el
   */
  removeLayoutClasses($el) {
    $el.removeClass((index, css) =>
      (css.match(/(^|\s)body-layout--\S+/g) || []).join(" ")
    );
  },

  /**
   * Get stored layout pref: specific to app section, ie pref could be square for portfolio, circle for pics.
   * @return {string}
   */
  getLayoutPref() {
    return window.localStorage.getItem(
      `${this.PREF_STORAGE_KEY}.${this.appSection}`
    );
  },

  /**
   * Get the current active layout if one exists.
   */
  getActiveLayout() {
    return urlUtil.getParam("l");
  },

  /**
   * In the event that the current layout does not match stored preference, switch it.
   */
  correctLayout() {
    const layout = this.getActiveLayout();
    const layoutPref = this.getLayoutPref();

    if (!_.isNull(layoutPref) && layoutPref !== layout) {
      this.switchLayout(
        this.$layoutSwitcher.find(
          `.layout-switcher__link[data-layout="${layoutPref}"]`
        )
      );
    } else {
      // the active class is not added by default in the DOM to handle cases where we needed to
      // correct layout above(causes noticeable flash in UI). In the event that we did not switch layouts, we'll
      // need to add class.
      const activeLayout = layout || this.defaultLayout;
      this.$layoutSwitcher
        .find(`.layout-switcher__link[data-layout="${activeLayout}"]`)
        .addClass(this.ACTIVE_CLASS);
    }
  },

  /**
   * Bind event handlers for module.
   */
  bindEventHandlers() {
    const self = this;
    this.$layoutSwitcher
      .find(".layout-switcher__link")
      .on("click", function (event) {
        event.preventDefault();
        self.$body.addClass(self.ENABLE_LAYOUT_TRANSITION_CLASS);
        self.switchLayout.call(self, $(this), true);
      });
  },

  /**
   * Init module
   *
   * @param {string} defaultLayout
   */
  init(defaultLayout) {
    this.$layoutSwitcher = $(".layout-switcher");
    if (!this.$layoutSwitcher.length) {
      return;
    }
    this.defaultLayout = this.$layoutSwitcher.attr("data-default-layout");
    this.$body = $("body");
    this.appSection = this.$layoutSwitcher.attr("data-app-section");

    this.bindEventHandlers();
    this.correctLayout();
  },
};

export default layoutSwitcher;
